<template>
  <v-dialog 
    v-model="navigation.SINPEPaymentDialogIsVisible"
    @update:model-value="navigation.SINPEPaymentDialogIsVisible == false ? closeSINPEPaymentDialog() : null"
    :persistent="loader.getSystemInformationData || loader.selectSINPEPaymentFromSINPEPaymentDialog || loader.confirmSINPEPayment"
    :max-width="$vuetify.display.smAndUp ? '65vw' : '90vw'"
  >
    <v-card :max-width="$vuetify.display.smAndUp ? '65vw' : '90vw'">
      <div style="position: sticky; top: 0; z-index: 10; background: white;">
        <v-card color="primary" rounded="0" elevation="0" class="headerCard">
          <div class="titleContainer">
            <v-icon color="indigo" style="margin-right: 10px;">mdi-cash-multiple</v-icon>
            <p class="titleText">CONFIRMAR PAGO</p>
          </div>
          <div class="actionsContainer">
            <v-btn 
              @click="closeSINPEPaymentDialog()"
              :disabled="loader.getSystemInformationData || loader.selectSINPEPaymentFromSINPEPaymentDialog || loader.confirmSINPEPayment"
              color="error" 
              class="hoverableText" 
            >
              <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
              <p>CERRAR</p>
            </v-btn>
          </div>
        </v-card>
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
      </div>  
      <div v-if="loader.getSystemInformationData || loader.selectSINPEPaymentFromSINPEPaymentDialog || loader.confirmSINPEPayment" style="display: flex; justify-content: center; align-items: center; width: 100%; padding: 10px 0px;">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else>
        <div v-if="loader.selectSINPEPaymentFromSINPEPaymentDialog">
          <div style="width: 100%; text-align: center; margin: 10px 0px 10px 0px;">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </div>
        <div v-else>
          <v-data-table :headers="display.SINPEPaymentHeaders" :items="display.SINPEPayment" fixed-header :items-per-page="display.SINPEPayment.length > 50 ? 50 : -1" style="max-height: 500px; overflow-y: auto;">
            <template v-slot:header.SINPEPaymentID>
              <div style="display: flex; align-items: center; white-space: nowrap;">
              <v-icon color="indigo" style="margin-right: 5px;">mdi-barcode</v-icon>
              <span style="margin-right: 10px; display: flex; align-items: center;"><strong>ID</strong></span>
            </div>
            </template>
            <template v-slot:header.SINPEPaymentName>
              <div style="display: flex; align-items: center; white-space: nowrap;">
                <v-icon color="indigo" style="margin-right: 5px;">mdi-account</v-icon>
                <span style="margin-right: 10px; display: flex; align-items: center;"><strong>NOMBRE</strong></span>
              </div>
            </template>
            <template v-slot:header.SINPEPaymentNote>
              <div style="display: flex; align-items: center; white-space: nowrap;">
                <v-icon color="indigo" style="margin-right: 5px;">mdi-note-text</v-icon>
                <span style="margin-right: 10px; display: flex; align-items: center;"><strong>DESCRIPCIÓN</strong></span>
              </div>
            </template>
            <template v-slot:header.SINPEPaymentAmount>
              <div style="display: flex; align-items: center; white-space: nowrap;">
                <v-icon color="indigo" style="margin-right: 5px;">mdi-cash</v-icon>
                <span style="margin-right: 10px; display: flex; align-items: center;"><strong>MONTO</strong></span>
              </div>
            </template>
            <template v-slot:header.SINPEPaymentCreationDatetime>
              <div style="display: flex; align-items: center; white-space: nowrap;">
                <v-icon color="indigo" style="margin-right: 5px;">mdi-calendar</v-icon>
                <span style="margin-right: 10px; display: flex; align-items: center;"><strong>RECIBIDO EL</strong></span>
              </div>
            </template>
            <template v-slot:item.SINPEPaymentID="{ item }">
              <div style="display: flex; align-items: center;">
                <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Copiar ID al portapapeles" location="top">
                  <template v-slot:activator="{ props }">
                    <p v-bind="props" @click="$generalFunctions.default.copyToClipboard(this, 'ID del pago', 'o', item.SINPEPaymentID)" class="hoverableElement" style="user-select: none; color: #3F51B5"><strong>{{ item.SINPEPaymentID }}</strong></p>
                  </template>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:item.SINPEPaymentName="{ item }">
              <p>{{ item.SINPEPaymentName }}</p>
            </template>
            <template v-slot:item.SINPEPaymentNote="{ item }">
              <p>{{ item.SINPEPaymentNote && /\S/.test(item.SINPEPaymentNote) ? item.SINPEPaymentNote : 'Sin descripción' }}</p>
            </template>
            <template v-slot:item.SINPEPaymentAmount="{ item }">
              <p><span style="margin-right: 5px; color: #3F51B5;"><strong>₡</strong></span>{{ $displayFunctions.default.parseAmountToDisplay(item.SINPEPaymentAmount) }}</p>
            </template>
            <template v-slot:item.SINPEPaymentCreationDatetime="{ item }">
              <p>{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(item.SINPEPaymentCreationDatetime) }}</p>
            </template>
            <template v-slot:item.SINPEPaymentAction="{ item }">
              <v-btn 
                v-if="Math.abs(item.SINPEPaymentAmount - navigation.amount) <= 100"
                @click="confirmSINPEPayment(item)"
                color="indigo" 
                class="hoverableText"
              >
                <v-icon style="margin-right: 10px;">mdi-check-circle</v-icon>
                <h4>ASOCIAR A LA {{ navigation.CRMWhatsappConversationID ? 'CONVERSACIÓN' : 'ORDEN' }}</h4>
              </v-btn>
            </template>
            <template v-slot:bottom v-if="display.SINPEPayment.length <= 50"></template>
          </v-data-table>
          <v-card color="primary" elevation="0" rounded="0" class="twoColumnContainer">
            <v-text-field 
              v-model="input.CRMTokenValue" 
              type="number"
              @keypress="$generalFunctions.default.allowOnlyNumberOnInput($event)"
              @keydown.enter.prevent="confirmSINPEPaymentByCRMToken()"
              label="Validar mediante token" 
              variant="solo-filled" 
              density="compact" 
              autocomplete="off" 
              hide-details 
              hide-spin-buttons
            ></v-text-field>
            <v-btn 
              @click="confirmSINPEPaymentByCRMToken()"
              :disabled="loader.getSystemInformationData || loader.confirmSINPEPayment" 
              color="indigo" 
              class="hoverableText"
            >
              <v-icon style="margin-right: 10px;">mdi-check-circle</v-icon>
              <p>CONFIRMAR PAGO</p>
            </v-btn>
          </v-card>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
  .headerCard {
    padding: 15px;
    display: grid;
    justify-content: center;
    align-items: center;
    gap: 10px;
    grid-template-columns: repeat(2, 1fr);
  }
  .titleContainer {
    display: flex;
    align-items: center;
  }
  .titleText {
    font-size: large;
    font-weight: bold;
  }
  .actionsContainer {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }
  .twoColumnContainer {
    padding: 15px;
    display: flex;
    align-items: center;
    gap: 15px;
  }
  @media (max-width: 1200px) {
    .twoColumnContainer {
      flex-direction: column;
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    data: () => 
    ({
      input:
      {
        CRMTokenValue: null
      },
      display:
      {
        SINPEPayment: [],
        SINPEPaymentHeaders:
        [
          {title: 'ID', key: 'SINPEPaymentID', sortable: false},
          {title: 'NOMBRE', key: 'SINPEPaymentName', sortable: false},
          {title: 'DESCRIPCIÓN', key: 'SINPEPaymentNote', sortable: false},
          {title: 'MONTO', key: 'SINPEPaymentAmount', sortable: false},
          {title: 'RECIBIDO EL', key: 'SINPEPaymentCreationDatetime', sortable: false},
          {title: null, key: 'SINPEPaymentAction', sortable: false}
        ]
      },
      navigation: 
      {
        amount: null,
        SINPEPaymentDialogIsVisible: false,
        CRMWhatsappConversationID: null,
        CRMWhatsappInvoiceID: null
      },
      loader: 
      {
        getSystemInformationData: false,
        selectSINPEPaymentFromSINPEPaymentDialog: false,
        confirmSINPEPayment: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    methods:
    {

      async selectSINPEPaymentFromSINPEPaymentDialog(){
        this.loader.selectSINPEPaymentFromSINPEPaymentDialog = true;
        const selectSINPEPaymentFromSINPEPaymentDialogRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          }
        };
        const selectSINPEPaymentFromSINPEPaymentDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/SINPEPayment/functions/selectSINPEPaymentFromSINPEPaymentDialog', selectSINPEPaymentFromSINPEPaymentDialogRequestQuery);
        if (selectSINPEPaymentFromSINPEPaymentDialogResult.success){
          this.display.SINPEPayment = selectSINPEPaymentFromSINPEPaymentDialogResult.result;
          this.loader.selectSINPEPaymentFromSINPEPaymentDialog = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog(`selectSINPEPaymentFromSINPEPaymentDialog_${this.navigation.CRMWhatsappConversationID}_error`, 'error', `Ha ocurrido un error inesperado al seleccionar los pagos por SINPE disponibles, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
        }
      },

      async confirmSINPEPayment(SINPEPayment){
        this.loader.confirmSINPEPayment = true;
        const confirmSINPEPaymentRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'SINPEPaymentID': SINPEPayment.SINPEPaymentID,
          'SINPEPaymentAmount': SINPEPayment.SINPEPaymentAmount,
          'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversationID,
          'CRMWhatsappInvoiceID': this.navigation.CRMWhatsappInvoiceID
        };
        const confirmSINPEPaymentResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/SINPEPayment/functions/confirmSINPEPayment', confirmSINPEPaymentRequestQuery);
        if (confirmSINPEPaymentResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('confirmSINPEPayment_success', 'success', `Se ha asociado el pago por SINPE a la ${this.navigation.CRMWhatsappConversationID ? 'conversación' : 'orden'}`, null, true);
          this.closeSINPEPaymentDialog();
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('confirmSINPEPayment_error', 'error', `Ha ocurrido un error inesperado al asociar el pago por SINPE a la ${this.navigation.CRMWhatsappConversationID ? 'conversación' : 'orden'}, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
        }
        this.loader.confirmSINPEPayment = false;
      },

      async confirmSINPEPaymentByCRMToken(){
        this.loader.confirmSINPEPayment = true;
        const confirmSINPEPaymentByCRMTokenRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMTokenValue': this.input.CRMTokenValue,
          'SINPEPaymentAmount': this.navigation.amount,
          'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversationID,
          'CRMWhatsappInvoiceID': this.navigation.CRMWhatsappInvoiceID
        };
        const confirmSINPEPaymentByCRMTokenResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/SINPEPayment/functions/confirmSINPEPaymentByCRMToken', confirmSINPEPaymentByCRMTokenRequestQuery);
        if (confirmSINPEPaymentByCRMTokenResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('confirmSINPEPaymentByCRMToken_success', 'success', `Se ha asociado el pago por SINPE a la ${this.navigation.CRMWhatsappConversationID ? 'conversación' : 'orden'}`, null, true);
          this.closeSINPEPaymentDialog();
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('confirmSINPEPaymentByCRMToken_error', 'error', `Ha ocurrido un error inesperado al asociar el pago por SINPE a la ${this.navigation.CRMWhatsappConversationID ? 'conversación' : 'orden'}, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
        }
        this.loader.confirmSINPEPayment = false;
      },


      async getSystemInformationData(){
        this.loader.getSystemInformationData = true;
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            if (!this.systemInformationData.updateSubscription){
              this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
                this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
              });
            }
            this.loader.getSystemInformationData = false;
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('SINPEPaymentDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('SINPEPaymentDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      },

      async openSINPEPaymentDialog(CRMWhatsappConversationID, CRMWhatsappInvoiceID, amount){
        this.navigation.CRMWhatsappConversationID = CRMWhatsappConversationID;
        this.navigation.CRMWhatsappInvoiceID = CRMWhatsappInvoiceID;
        this.navigation.amount = amount;
        this.navigation.SINPEPaymentDialogIsVisible = true;
        await this.getSystemInformationData();
        await this.selectSINPEPaymentFromSINPEPaymentDialog();
      },

      closeSINPEPaymentDialog(){
        this.navigation.SINPEPaymentDialogIsVisible = false;
        this.$emit('closeSINPEPaymentDialog');
      }
    }
  }
</script>